export default __webpack_public_path__ + "assets/images/aistudio/empty_state/3799678c65e26113174e201f51f8264e.png";